import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";
import Link from "@tiptap/extension-link";
import TextAlign from "@tiptap/extension-text-align";
import { Bold, Italic, Underline as UIcon, Heading1, Heading2, Heading3, Pilcrow, List, ListOrdered, AlignLeft, AlignCenter, AlignRight, Link2, Link2Off } from "lucide-react";

function Btn({ active, onClick, title, testid, children }) {
  return (
    <button type="button" title={title} data-testid={testid} onMouseDown={(e) => e.preventDefault()} onClick={onClick}
      className={`h-8 w-8 flex items-center justify-center rounded-sm border transition-colors ${active ? "bg-primary text-primary-foreground border-primary" : "bg-input border-border text-muted-foreground hover:text-foreground"}`}>
      {children}
    </button>
  );
}

export function RichText({ value, onChange }) {
  const editor = useEditor({
    extensions: [
      StarterKit,
      Underline,
      Link.configure({ openOnClick: false, autolink: true, HTMLAttributes: { rel: "noopener" } }),
      TextAlign.configure({ types: ["heading", "paragraph"] }),
    ],
    content: value || "<p></p>",
    onUpdate: ({ editor }) => onChange(editor.getHTML()),
  });

  if (!editor) return null;
  const setLink = () => {
    const prev = editor.getAttributes("link").href || "";
    const url = window.prompt("URL do link (deixe vazio para remover):", prev);
    if (url === null) return;
    if (url === "") { editor.chain().focus().unsetLink().run(); return; }
    const nova = window.confirm("Abrir em nova aba?");
    editor.chain().focus().extendMarkRange("link").setLink({ href: url, target: nova ? "_blank" : null }).run();
  };

  return (
    <div className="rt-editor border border-border rounded-sm bg-input">
      <div className="flex flex-wrap items-center gap-1 p-1.5 border-b border-border">
        <Btn active={editor.isActive("bold")} onClick={() => editor.chain().focus().toggleBold().run()} title="Negrito" testid="rt-bold"><Bold className="h-4 w-4" /></Btn>
        <Btn active={editor.isActive("italic")} onClick={() => editor.chain().focus().toggleItalic().run()} title="Itálico" testid="rt-italic"><Italic className="h-4 w-4" /></Btn>
        <Btn active={editor.isActive("underline")} onClick={() => editor.chain().focus().toggleUnderline().run()} title="Sublinhado" testid="rt-underline"><UIcon className="h-4 w-4" /></Btn>
        <span className="w-px h-6 bg-border mx-0.5" />
        <Btn active={editor.isActive("heading", { level: 1 })} onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()} title="Título 1" testid="rt-h1"><Heading1 className="h-4 w-4" /></Btn>
        <Btn active={editor.isActive("heading", { level: 2 })} onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()} title="Título 2" testid="rt-h2"><Heading2 className="h-4 w-4" /></Btn>
        <Btn active={editor.isActive("heading", { level: 3 })} onClick={() => editor.chain().focus().toggleHeading({ level: 3 }).run()} title="Título 3" testid="rt-h3"><Heading3 className="h-4 w-4" /></Btn>
        <Btn active={editor.isActive("paragraph")} onClick={() => editor.chain().focus().setParagraph().run()} title="Parágrafo" testid="rt-p"><Pilcrow className="h-4 w-4" /></Btn>
        <span className="w-px h-6 bg-border mx-0.5" />
        <Btn active={editor.isActive("bulletList")} onClick={() => editor.chain().focus().toggleBulletList().run()} title="Lista" testid="rt-ul"><List className="h-4 w-4" /></Btn>
        <Btn active={editor.isActive("orderedList")} onClick={() => editor.chain().focus().toggleOrderedList().run()} title="Lista numerada" testid="rt-ol"><ListOrdered className="h-4 w-4" /></Btn>
        <span className="w-px h-6 bg-border mx-0.5" />
        <Btn active={editor.isActive({ textAlign: "left" })} onClick={() => editor.chain().focus().setTextAlign("left").run()} title="Esquerda" testid="rt-al"><AlignLeft className="h-4 w-4" /></Btn>
        <Btn active={editor.isActive({ textAlign: "center" })} onClick={() => editor.chain().focus().setTextAlign("center").run()} title="Centro" testid="rt-ac"><AlignCenter className="h-4 w-4" /></Btn>
        <Btn active={editor.isActive({ textAlign: "right" })} onClick={() => editor.chain().focus().setTextAlign("right").run()} title="Direita" testid="rt-ar"><AlignRight className="h-4 w-4" /></Btn>
        <span className="w-px h-6 bg-border mx-0.5" />
        <Btn active={editor.isActive("link")} onClick={setLink} title="Inserir link" testid="rt-link"><Link2 className="h-4 w-4" /></Btn>
        <Btn onClick={() => editor.chain().focus().unsetLink().run()} title="Remover link" testid="rt-unlink"><Link2Off className="h-4 w-4" /></Btn>
      </div>
      <EditorContent editor={editor} data-testid="rt-content" />
    </div>
  );
}
